import { render, staticRenderFns } from "./use-case-adder.vue?vue&type=template&id=ec0046e4&"
import script from "./use-case-adder.vue?vue&type=script&lang=ts&"
export * from "./use-case-adder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports